import request from '../utils/request';

// 根据ID获取商家认证详情
export function getMerchantCertificationById(id) {
  return request({
    url: `/merchant-certification/${id}`,
    method: 'get'
  });
}

// 分页查询商家认证列表
export function pageMerchantCertifications(params) {
  return request({
    url: '/merchant-certification/list',
    method: 'post',
    data: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      ...params
    }
  });
}

// 更新商家认证状态
export function updateMerchantCertificationStatus(data) {
  return request({
    url: '/merchant-certification/update-status',
    method: 'put',
    data
  });
}
